<template>
    <div class="card border-0 customer_mainlisting">
        <div class="sectionclsbodymain tsk_body_right_back">
            <div class="serach_controls_main tsk_controls_main_cls">
                <div class="serach_controls_main_row1">
                    <div class="tsk_top_filter_left">
                        <div class="serach_controls me-2">
                            <SearchSvgIcon />
                            <input type="search" class="formmginput-control tsk_search" id="searchTxtId" placeholder="Search..." v-on:keyup="reloadSearch()">
                        </div>
                    </div>                   
                    <div class="tsk_top_filter_right">  
                        <div class="tsk_top_filter_right">   
                        <AddEditCustomer @reload-table-data="reloadSearch" ref="childComponentCustomerRef" />
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body p-0">
            <div class="table-responsive pageTblHeightCls" v-if="isResonsiveCls == 1">
                <table class="table table-bordered customer_list_tsk" id="dataTable" width="100%" cellspacing="0">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Total Ticket</th>
                            <th>Pin</th>
                            <th>Created at</th>
                            <th>Last activity at</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody class="tbodyCls shimmer-wrapper" v-if="$store.state.customer.tableLoader === 1">
                        <tr class="text-center " v-for="index in 15" :key="index">
                            <td v-for="index1 in 6" :key="index1">
                                <span class="shimmer-line shimmer-line-br shimmer-line-full shimmer-animate"></span>
                            </td>
                        </tr>
                    </tbody>
                    <tbody class="tbodyCls noDATA" v-else-if="$store.state.customer.tableLoader === 2">
                        <tr class="text-center">
                            <td colspan="6">
                                <ComponentNoData />
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr v-for="(item) in $store.state.customer.customerList" :key="item._id">
                            <td>{{ item.user_id }}</td>
                            <td>{{ item.total_ticket }}</td>
                            <td>{{ item.mpin }}</td>
                            <td>{{ formatDateTime(item.createdAt) }}</td>
                            <td>{{ formatDateTime(item.updatedAt) }}</td>
                            <td>
                                <router-link :to="`/tickets?name=${item.user_id}`" class="cls_action">
                                    <ViewSvgIcon />
                                </router-link>
                                <input type="hidden" :class="'userClsName'+item._id" :value="item.user_id" />
                                <input type="hidden" :class="'userClsMpin'+item._id" :value="item.mpin" />
                                <a href="javascript:;" class="cls_action" v-bind:id="item.user_id" v-on:click="modalEditOpen(item._id)" title="Edit">
                                    <EditSvgIcon />
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="right-bodypart pageTblHeightCls overflow-auto" v-if="isResonsiveCls == 2">
                <div  class="Setcard_row shimmer-wrapper" v-if="$store.state.customer.tableLoader === 1">                   
                    <div class="card_ticket_S" v-for="index in 8" :key="index">
                        <div class="topsetheadeTcktr">
                            <label class="d-flex">
                                 <span class="stroke animate title w-100"></span>
                            </label>
                        </div>
                        <div class="card_ticket_body" >
                            <label class="d-flex">
                                <span class="stroke animate title w-50 mb-2"></span>
                                <b class="stroke animate title w-25 mb-2"></b>
                            </label>
                            <label class="d-flex">
                                <span class="stroke animate title w-50 mb-2"></span>
                                <b class="stroke animate title w-25 mb-2"></b>
                            </label>    
                            <label class="d-flex">
                                <span class="stroke animate title w-50 mb-2"></span>
                                <b class="stroke animate title w-25"></b>
                            </label>        
                        </div>
                    </div>                    
                </div>
                <div  class="Setcard_row shimmer-wrapper" v-else-if="$store.state.customer.tableLoader === 2">
                    <ComponentNoData />
                </div>
                <div class="Setcard_row" v-else>
                    <div class="card_ticket_S" v-for="(item) in customerList" :key="item._id">
                        <div class="topsetheadeTcktr">
                            <label class="d-flex">
                                <b>{{ item.user_id }}</b>
                                <span v-b-tooltip.hover v-bind:title="'View Detail'">
                                    <router-link class="" :to="`/tickets?name=${item.user_id}`">
                                        <ViewSvgIcon />
                                    </router-link>
                                </span>
                            </label>
                        </div>
                        <div class="card_ticket_body" >
                            <label class="d-flex">
                                <span>Total Ticket</span>
                                <b>{{ item.total_ticket }}</b>
                            </label>    
                            <label class="d-flex">
                                <span>Pin</span>
                                <b>{{ item.mpin }}</b>
                            </label>    
                            <label class="d-flex">
                                <span>Created at</span>
                                <b>{{ formatDateTime(item.createdAt) }}</b>
                            </label> 
                        </div>
                        <div class="card_ticket_body" v-if="item.updatedAt">
                            <label class="d-flex">
                                <span>Last activity at</span>
                                <b>{{ formatDateTime(item.updatedAt) }}</b>
                            </label> 
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex px-3 databottom justify-content-between align-content-center" v-if="$store.state.customer.tableLoader == 3">
                <p v-if="page * pageLength > $store.state.customer.totalRecord">Showing {{ formatMoney((page * pageLength) - pageLength + 1) }} to {{
                    formatMoney($store.state.customer.totalRecord) }} of {{ formatMoney($store.state.customer.totalRecord) }} entries</p>
                <p v-else>Showing {{ formatMoney((page * pageLength) - pageLength + 1) }} to {{ formatMoney(page * pageLength) }} of {{
                    formatMoney($store.state.customer.totalRecord) }} entries</p>
                <vs-pagination :total="$store.state.customer.totalLenght" :max="8" v-model="page" @click="reloadPagination(page)"></vs-pagination>
            </div>
        </div>
    </div>
    <input type="hidden" class="customerValId" id="customerValId"/>
    <input type="hidden" class="userMpin" id="userMpin"/>
    <input type="hidden" class="userName" id="userName"/>
</template>
<script>
import SearchSvgIcon from '@/components/Widgets/Icon/SearchSvgIcon.vue';
import ComponentNoData from '@/components/Widgets/Icon/ComponentNoData.vue';
import ViewSvgIcon from '@/components/Widgets/Icon/ViewSvgIcon.vue';
import AddEditCustomer from './AddEditCustomer.vue';
import EditSvgIcon from '@/components/Widgets/Icon/EditSvgIcon.vue';
import $ from "jquery";
import {
    ref
} from 'vue';
import {
    formatMoney,
    formatDateTime,
} from '../../../helper'
import axios from 'axios'
    export default {
        name: 'CustomerListingPage',
        components: {
            SearchSvgIcon,
            ComponentNoData,
            ViewSvgIcon,
            AddEditCustomer,
            EditSvgIcon,
        },
        data() {
            return {
                windowWidth: window.innerWidth,
                currentx: 5,
                page: 1,
                pageLength: this.$store.state.showEntries,
                searchKey: '',
                totalRecord: 0,
                totalLenght: 0,
                customerList: [],
                myValue: 'true',
                taskMainListHeight: 0,
                isResonsiveCls: 1,
            }
        },
        async mounted() {
            this.$store.state.pageTitle = 'Customers'
            this.$store.state.isAdmin = 2
            if(this.windowWidth < 991){
                this.isResonsiveCls = 2;
                $('.mainbody_cssclass').removeClass('sideMenuActive');
            }
            $('tbody').height(this.$store.state.tbody);
            $('.pageTblHeightCls').height(this.$store.state.pageTblHeightCls);
            if (this.$store.state.isActiveToken != '1') {
                // console.log(this.currentDate);
            } else {
                await this.loadCustomerData();
            }
            let temps = this
            $("body").on("click", '#searchTxtId', function () {
                if ($('#searchTxtId').val() != '') {
                    $('#searchTxtId').val('');
                    this.searchKey = '';
                    this.page = 1;
                    temps.reloadSearch()
                }
            });
            this.onResize();
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            })
        },
        computed: {
            iAT() {
                return this.$store.state.user.role_id
            },
        },
        watch: {
            async iAT(newValue) {
                if (this.$store.state.user.role_id != '') {
                    await this.loadCustomerData();
                }
                return newValue
            },
        },
        methods: {
            formatMoney,
            formatDateTime,
            startLoader () {
                this.$Progress.start()
            },
            finishLoader () {
                this.$Progress.finish()
            },
            async reloadPagination(itemObjKey) {
                if (itemObjKey > 0 && itemObjKey !== -1 && itemObjKey <= this.$store.state.customer.totalLenght) {
                    this.page = itemObjKey;
                    this.loadCustomerData();
                }
            },
            myChangeEvent(val) {
                this.myValueRole = val
                this.loadCustomerData();
            },
            mySelectEvent({ id, text }) {
                console.log({ id, text })
                this.page = 1;
                this.loadCustomerData();
            },
            async reloadSearch() {
                const searchCls = document.getElementById('searchTxtId').value;
                this.searchKey = searchCls.trim();
                this.page = 1;
                this.loadCustomerData();
            },
            async loadCustomerData() {
                this.tableLoader = 1

                    
                if (this.$store.state.customer.customerList.length > 0) {
                    // this.$store.state.customer.tableLoader = 3
                } else {
                    this.$store.state.customer.tableLoader = 1
                }
                let token = localStorage.getItem('supportSystemAdmin');
                if (!token) {
                    this.$store.state.user.accessToken = ''
                }
                this.startLoader()    
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
                await axios.get(process.env.VUE_APP_API_URL + 'customers/list', {
                        params: {
                            page: this.page,
                            pageLength: this.pageLength,
                            searchKey: this.searchKey,
                        }
                    })
                    .then((resp) => {
                        if (resp.status == 200 && resp.data.status == 'success') {
                            this.customerList = []
                            this.customerList = resp.data.data.records
                            this.totalRecord = resp.data.data.totalRecord
                            this.totalLenght = this.totalRecord / this.pageLength
                            this.totalLenght = Math.ceil(this.totalLenght);
                            this.$store.state.customer.customerList = resp.data.data.records;
                            this.$store.state.customer.totalLenght = this.totalLenght;
                            this.$store.state.customer.totalRecord = this.totalRecord;
                            if (this.$store.state.customer.customerList.length > 0) {
                                this.$store.state.customer.tableLoader = 3
                            } else {
                                this.$store.state.customer.tableLoader = 2
                            }
                            setTimeout(async () =>
                                this.onResize(),
                            100);
                            this.finishLoader()
                        }else{
                            this.$store.state.user.accessToken = ''
                            this.$store.state.isActiveToken = ''
                            this.$store.state.user.userInfo = ''
                            this.$store.state.isAdmin = 2 
                            localStorage.removeItem("supportSystemAdmin");
                            this.$router.push({
                                path: '/login'
                            })
                        }
                    })
                    .catch(error => {
                        console.error("There was an error!", error);
                        console.log("response", error.response.status);
                        console.log("message", error.response.data.message);
                        // this.errorRes = error.response.data.message;
                    })
            },
            onResize() {
                this.windowWidth = window.innerWidth
                this.windowHeight = window.innerHeight

                var headNavCls = $('.headNavCls').outerHeight() || 0;
                var tsk_controls_main_cls = $('.tsk_controls_main_cls').outerHeight() || 0;
                var thead = $('thead').outerHeight() || 0;
                var databottom = $('.databottom').outerHeight() || 0;

                var cntSubvar = headNavCls + tsk_controls_main_cls + thead + databottom
                var tabHei = headNavCls + tsk_controls_main_cls + databottom
                var cntSubvar1 = this.windowHeight - cntSubvar
                tabHei = this.windowHeight - tabHei
                this.taskMainListHeight = tabHei;
                this.$store.state.tbody = cntSubvar1
                $('tbody').height(this.$store.state.tbody);
                if(this.isResonsiveCls == 2){
                    tabHei = tabHei-20
                }
                this.$store.state.pageTblHeightCls = tabHei
                $('.pageTblHeightCls').height(this.$store.state.pageTblHeightCls);
                this.checkHeightScroll();
            },
            checkHeightScroll() {
                $('.table').removeClass('ScrollAddedCls');
                if (this.hasScrollBar() == true) {
                    $('.table').addClass('ScrollAddedCls');
                }
            },
            hasScrollBar() {
                if ($(".tbodyCls")[0]) {
                    return $('.tbodyCls').get(0).scrollHeight > $('.tbodyCls').height() + 10;
                } else {
                    return false;
                }
            },
            async modalEditOpen(customer_id) {
                $('.customerValId').val(customer_id);
                var userMpin = $('.userClsMpin'+customer_id).val();
                var userName = $('.userClsName'+customer_id).val();
                $('.userMpin').val(userMpin);
                $('.userName').val(userName);
                this.callChildCustomerMethod();
            },
        },
        setup() {
            const childComponentCustomerRef = ref(null);
            const callChildCustomerMethod = () => {
                if (childComponentCustomerRef.value) {
                    childComponentCustomerRef.value.modalEditOpen();
                }
            };
            return {
                childComponentCustomerRef,
                callChildCustomerMethod,
            };
        },
    }
</script>